import { FileOutlined, MessageOutlined } from '@ant-design/icons';
import { Table, Tooltip } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { t_billing_process } from 'types';
import ModalRegister from './ModalRegister/ModalRegister';

type Props = {
  dataSource: t_billing_process[];
  tab?: string;
  afterUpdate: () => void;
};

const formatter = new Intl.NumberFormat('ja-JP', {
  style: 'currency',
  currency: 'JPY',
});

const TableDeposit: FC<Props> = ({ dataSource, afterUpdate, tab }) => {
  const history = useHistory();
  const [dataDetail, setDataDetail] = useState<t_billing_process | null>(null);
  const [visible, setVisible] = useState<boolean>(false);
  const [openToolTip, setOpenToolTip] = useState<string | null>(null);

  const pushDetail = (data: t_billing_process) => {
    history.push('/billings/detail', { bill: data });
  };

  const changeVisible = (value: boolean) => {
    setVisible(value);
  };

  const columns: any = [
    {
      title: '',
      dataIndex: 'Status',
      key: 'Status',
      width: '1%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'center' },
            className: 'smallFont',
          },

          children: checkStatus(text) ? (
            <div style={{ position: 'relative' }}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="15" fill="white" stroke="#FF0000" stroke-width="2" />
              </svg>
              <svg
                style={{ position: 'absolute', left: '3px', top: '3px' }}
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="13" cy="13" r="12.75" fill="white" stroke="#FF0000" stroke-width="0.5" />
              </svg>
              <svg
                style={{ position: 'absolute', left: '6px', top: '5px' }}
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.9502 6.40222L16.847 6.26423C15.2593 6.70622 14.2102 6.87135 12.6517 6.74232C13.5089 5.55192 13.8375 4.55283 14.0027 3.99505C14.4344 3.81314 14.5837 3.69031 14.5039 3.33071L15.493 3.06568C15.6166 3.03255 15.7433 2.94892 15.7019 2.79437C15.6729 2.68619 15.6017 2.60588 15.4882 2.55345L14.1394 1.97069C14.0106 1.9224 13.9322 1.87715 13.824 1.90613C13.7004 1.93926 13.6551 2.01765 13.6181 2.12694L13.0373 3.35926L11.3836 3.80236L11.0275 2.47325C11.081 2.42577 11.357 2.21931 11.4064 2.15638C11.4445 2.11305 11.4856 2.01921 11.4649 1.94194C11.4152 1.75648 11.2369 1.77112 11.0164 1.81364L8.73292 2.1936L9.31267 4.35727L6.71626 5.05297L6.73748 4.69944L6.57354 4.64398C6.53768 4.81923 5.12387 11.9067 4.65727 13.009C4.37361 13.6813 4.08937 13.8569 3.45158 14.0112L3.48167 14.1853C4.9226 14.2465 5.1931 14.6378 5.38359 15.3487C5.45813 15.6269 5.44792 15.7125 5.42922 16.4463C5.4182 16.7143 5.48446 16.9616 5.49274 16.9925C5.68323 17.7034 6.40991 17.7572 6.79628 17.6536C7.64629 17.4259 7.875 16.4867 7.66381 15.6985C7.51473 15.1421 7.35271 14.9702 6.65716 14.2289C6.45181 14.0189 6.16697 13.6977 6.08829 13.4041C6.0593 13.2959 6.05819 13.2299 6.08163 13.0083L6.22167 11.1818C6.64309 11.0855 7.66725 10.8276 8.56748 10.3545C9.23833 12.8582 9.85536 15.1609 7.93165 17.3163L8.00811 17.478C10.9226 15.6204 11.1905 13.7762 11.1421 12.9775L14.4958 12.0789L15.2412 14.8608C15.3364 15.2162 15.4449 15.4356 15.8467 15.3279C16.1713 15.241 16.5875 15.0632 16.955 14.7659C17.2804 14.4966 17.2409 14.2255 17.1581 13.9164L15.7832 8.78545C15.8688 8.79565 16.4892 8.76193 16.5356 8.74951C16.6901 8.70809 16.6611 8.59991 16.5783 8.29081C16.2967 7.23989 16.7526 6.65393 16.9502 6.40222ZM11.9075 4.02642C11.6909 4.76359 11.3887 5.49056 10.8611 6.42703C9.71052 6.08932 8.83587 5.54515 8.35285 4.97887L11.9075 4.02642ZM10.0628 7.65136C8.85993 9.28226 7.7304 10.1978 6.24097 10.9447L6.68868 5.25914L6.82282 5.38884L7.81193 5.12381C8.24201 6.23434 9.13352 7.08871 10.0628 7.65136ZM13.9507 8.74642L13.6137 8.78701L13.8995 9.8534L10.7312 10.7023C10.6868 10.5983 10.6081 10.3046 10.5543 10.1037C10.7684 9.91383 10.9445 9.76727 10.8907 9.56635C10.8534 9.42726 10.7215 9.42948 10.605 9.42756L9.9959 9.44169C10.552 9.04422 10.8155 8.79139 11.3807 8.24241C12.3602 8.55971 13.1807 8.65458 13.9507 8.74642ZM14.4047 11.7389L11.1128 12.6209C11.0214 12.0325 10.9405 11.607 10.8069 11.0465L13.9906 10.1934L14.4047 11.7389ZM5.3924 5.49053C5.10666 4.42414 3.6897 3.71057 1.91239 4.18679C1.68057 4.24891 1.51471 4.30992 1.33339 4.37507L1.3748 4.52961C1.47995 4.55113 2.62946 4.82288 3.23065 5.95381C3.40731 6.30402 3.78437 7.03121 4.57256 6.82002C4.94348 6.72063 5.59531 6.24781 5.3924 5.49053ZM5.18182 8.66106C4.8671 7.48649 3.06738 7.32271 2.07827 7.58775C1.81554 7.65814 1.70019 7.72218 1.55806 7.80996L1.58402 7.96865C2.80665 8.20423 3.14977 8.99021 3.20664 9.14062C3.47743 9.78033 3.68833 10.3201 4.46107 10.1131C5.23381 9.90603 5.28535 9.04743 5.18182 8.66106Z"
                  fill="#FF0000"
                />
              </svg>
            </div>
          ) : (
            ''
          ),
        };
      },
    },
    {
      title: '取引先番号',
      dataIndex: 'facility_code',
      key: 'facility_code',
      width: '10%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: '#f6f6f6' },
            className: 'smallFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '請求書',
      dataIndex: 'invoice',
      key: 'invoice',
      width: '7%',
      align: 'center',
      render(text: string, row: t_billing_process, index: number) {
        return {
          props: {
            style: { textAlign: 'center' },
            className: 'smallFont',
          },
          children: (
            <div onClick={() => pushDetail(row)} className="invoice-icon">
              <FileOutlined />
            </div>
          ),
        };
      },
    },
    {
      title: '医療機関名',
      dataIndex: 'facility_id',
      key: 'facility_id',
      width: '14%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: '#f6f6f6', paddingLeft: '5px' },
            className: 'smallFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '入金名',
      dataIndex: 'account_name',
      key: 'account_name',
      width: '12%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'smallFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '請求額',
      dataIndex: 'billing_amount',
      key: 'billing_amount',
      width: '7%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: '#f6f6f6', paddingLeft: '1px' },
            className: 'smallFont',
          },
          children: <div>{text ? formatter.format(Number(text)) : ''}</div>,
        };
      },
    },
    {
      title: '入金額',
      dataIndex: 'payment_amount',
      key: 'payment_amount',
      width: '8%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', paddingLeft: '1px' },
            className: 'smallFont',
          },
          children: <div>{text ? formatter.format(Number(text)) : ''}</div>,
        };
      },
    },
    {
      title: '繰越額',
      dataIndex: 'carried_forward',
      key: 'carried_forward',
      width: '10%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', background: '#f6f6f6', paddingLeft: '1px' },
            className: 'smallFont',
          },
          children: <div>{text ? formatter.format(Number(text)) : ''}</div>,
        };
      },
    },
    {
      title: '入金日',
      dataIndex: 'payment_date',
      key: 'payment_date',
      width: '7%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', paddingLeft: '1px' },
            className: 'smallFont',
          },
          children: <div>{text ? moment(text).format('YYYY/MM/DD') : ''}</div>,
        };
      },
    },
    {
      title: '備考',
      dataIndex: 'payment_remark',
      key: 'payment_remark',
      width: '9%',
      align: 'center',
      render(text: string, row: t_billing_process, index: number) {
        return {
          props: {
            style: { textAlign: 'center', background: '#f6f6f6' },
            className: 'smallFont',
          },
          children: (
            <div
              onClick={() =>
                setOpenToolTip((oldState) => {
                  if (oldState === row.i_id) {
                    return null;
                  }
                  return row.i_id;
                })
              }
            >
              <Tooltip
                visible={openToolTip === row.i_id}
                placement="topRight"
                color={'white'}
                key={'white'}
                title={text}
              >
                <MessageOutlined className="svg1" />
              </Tooltip>
            </div>
          ),
        };
      },
    },
    {
      title: '入金処理',
      dataIndex: 'Status',
      width: '6%',
      align: 'center',
      render(text: string, row: t_billing_process, index: number) {
        let textStatus = '';

        if (text === '請求書登録済' || text === 'Invoicing completed') {
          textStatus = '登録';
        }
        if (text === '請求書発行済' || text === 'invoice issued') {
          textStatus = '登録';
        }
        if (text === '入金済み' || text === 'already deposited') {
          textStatus = '編集';
        }
        if (text === '終了' || text === 'Closed') {
          textStatus = '表示';
        }
        return {
          props: {
            style: { textAlign: 'center', backgroundColor: '#ff8a00', padding: 0, color: '#fff' },
            className: 'smallFont',
          },
          children: (
            <div
              onClick={() => {
                setDataDetail(row);
                setVisible(true);
              }}
            >
              {textStatus}
            </div>
          ),
        };
      },
    },
  ];

  if (tab === '振込') {
    columns.splice(7, 0, {
      title: '振込手数料',
      dataIndex: 'payment_fees',
      key: 'payment_fees',
      width: '8%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left', paddingLeft: '1px' },
            className: 'smallFont',
          },
          children: <div>{text ? formatter.format(Number(text)) : ''}</div>,
        };
      },
    });
  }

  if (tab === 'カード') {
    const index = columns.findIndex((f: any) => f.dataIndex === 'account_name');
    if (index) {
      columns.splice(index, 1);
    }
  }

  return (
    <div>
      <Table columns={columns} dataSource={dataSource} pagination={false} className={'smallFont'} />
      <ModalRegister
        data={dataDetail}
        visible={visible}
        handleChangeVisible={changeVisible}
        afterUpdate={afterUpdate}
      />
    </div>
  );
};

const checkStatus = (value: string) => {
  switch (value) {
    case 'already deposited':
      return true;
    case 'Closed':
      return true;
    case '入金済み':
      return true;
    case '終了':
      return true;
    default:
      return false;
  }
};

export default TableDeposit;
